<template>
  <div ref="numBox" class="number-box">
    <p v-for="(item, index) in computeNumber" :key="index" :style="{ color: `${colors}`, padding: `${isNaN(item) ? '0 7px' : ''}` }" class="box-item">
      <i v-if="!isNaN(item)">
        <span ref="numberItem">0<br />1<br />2<br />3<br />4<br />5<br />6<br />7<br />8<br />9</span>
      </i>
      <i v-else
        ><b>{{ item }}</b></i
      >
    </p>
  </div>
</template>
<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    numbers: {
      type: String
    },
    // eslint-disable-next-line vue/require-default-prop
    colors: {
      type: String
    }
  },
   watch: {
    numbers: {
      immediate: true,
      handler(val) {
        this.number = val
        this.refresh()
      }
    }
  },
  data() {
    return {
      maxLen: 6, // 已不再用于补零，仅保留不破坏外部依赖
      computeNumber: [],
      timeTicket: null,
      number: '0'
    }
  },
  mounted() {
    // this.increaseNumber();
  },
  destroyed() {
    window.clearTimeout(this.timeTicket)
    this.timeTicket = null
  },
  created() {
    this.refresh()
    this.$nextTick(() => {
      this.number = this.numbers
      if (this.$refs.numBox) {
        this.$refs.numBox.style.opacity = 1
      }
      this.refresh()
    })
  },
  methods: {
    // 补0 操作 返回数组 num 被操作数 n 总长度
    prefixZero(num, n) {
      return (Array(n).join(0) + num).slice(n - 1).split('')
    },
    // 获得随机数
    getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    // 定时增长数字
    // increaseNumber () {
    //     // this.refresh()
    //     // this.timeTicket = setTimeout(this.increaseNumber,5000);
    // },
    // 定时刷新数据
    refresh() {
      const safeStr = this.sanitizeNumber(this.number)
      this.computeNumber = safeStr.split('')
      this.$nextTick(() => this.setNumberTransform())
    },
    // 过滤非数字字符，保留数字和一个小数点，空则返回 "0"
    sanitizeNumber(val) {
      const str = (val ?? '').toString()
      // 仅保留数字和小数点
      const cleaned = str.replace(/[^\d.]/g, '')
      // 若有多个小数点，保留第一个，其余移除
      const parts = cleaned.split('.')
      const normalized = parts.length > 1
        ? `${parts.shift()}.${parts.join('')}`
        : cleaned
      // 处理以点开头的情况，前置 0
      const withLeading = normalized.startsWith('.') ? `0${normalized}` : normalized
      // 最终兜底
      return withLeading || '0'
    },
    // 设置每一位数字的偏移
    setNumberTransform() {
      // let numberItems = this.$refs.numberItem
      // for (let index = 0; index < numberItems.length; index++) {
      //     let elem = numberItems[index]
      //     elem.style.transform = `translate(-50%, -${Number(this.computeNumber[index] * 10)}%)`;
      //     console.log(elem)
      // }
      const numberItems = this.$refs.numberItem
      const numberArr = this.computeNumber.filter((item) => !isNaN(item))
      if (!numberItems || !numberArr.length) return
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index]
        if (!elem || numberArr[index] === undefined) continue
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
      }
    }
  }
}
</script>
<style scoped lang="scss">
.number-box {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 7% auto 0;
}
p {
  /* flex: 1; */
  height: 40px;
  line-height: 60px;
  /* background: #2a3242; */
  /* margin: 0 26px 0 0; */
  color: #fff;
  text-align: center;
  border-radius: 12px;
  padding: 0 12px;
  display: inline-block;
  font-size: 62px;
  position: relative;
  /* writing-mode: vertical-lr; */
  /* text-orientation: upright; */
  overflow: hidden;
}
p:last-child {
  margin: 0px;
}
b {
  /* color:#9186e0; */
  font-size: 40px;
  font-weight: normal;
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform 1s;
  /* letter-spacing: 10px; */
}
span {
  /* color:#9186e0; */
  font-size: 40px;
  font-family: 'Arial';
  font-weight: normal;
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform 1s;
  /* letter-spacing: 10px; */
}
</style>
